import { gql, useMutation } from 'urql';

export const EVENT_MUTATION = gql`
  mutation updateEvent($id: ID!, $active: Boolean, $formId: Int) {
    updateEvent(eventId: $id, input: { active: $active, formId: $formId }) {
      id
      active
      formId
    }
  }
`;

interface IEventResponse {
  id: number;
  active?: boolean;
  formId?: number;
}

type IEventVariables = IEventResponse;

export const useUpdateEventMutation = () => {
  return useMutation<IEventResponse, IEventVariables>(EVENT_MUTATION);
};
